export default {
 getWishlistProductCount(state) {
   return state.productCount;
 }
};
